import React from 'react';
import { withFormsy } from 'formsy-react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

class RangeInput extends React.Component {
  showError() {
    const { isPristine, isValid } = this.props;

    if (isPristine()) {
      return false;
    }

    return !isValid();
  }

  getPropsForState() {
    const { showRequired } = this.props;

    return {
      error: this.showError(),
      showRequired: showRequired(),
    };
  }

  extractInputProps() {
    const {
      setValidations,
      setValue,
      resetValue,
      getValue,
      hasValue,
      getErrorMessage,
      getErrorMessages,
      isFormDisabled,
      isValid,
      isPristine,
      isFormSubmitted,
      isRequired,
      showRequired,
      showError,
      isValidValue,
      validationError,
      validationErrors,
      value,
      innerRef,
      ...inputProps
    } = this.props;

    return inputProps;
  }

  render() {
    const { getValue, setValue } = this.props;
    const inputProps = this.extractInputProps();
    const validationProps = this.getPropsForState();
    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flex: '0 1 50px;',
            fontSize: '10px',
            justifyContent: 'flex-start',
          }}
        >
          altitude
        </div>
        <div
          style={{
            display: 'flex',
            flex: 1,
            paddingLeft: '10px',
            paddingRight: '10px',
          }}
        >
          <InputRange
            step={5}
            maxValue={this.props.maxValue}
            minValue={this.props.minValue}
            value={getValue() || 0}
            onChange={value => setValue(value)}
            formatLabel={value => false}
            {...inputProps}
            {...validationProps}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flex: '0 0 40px',
            fontSize: '10px',
            justifyContent: 'flex-end',
          }}
        >
          {`${getValue() || 0}cm`}
        </div>
      </div>
    );
  }
}

RangeInput.defaultProps = {
  className: '',
};

RangeInput.propTypes = {
  maxValue: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
};

export default withFormsy(Radium(RangeInput));



// WEBPACK FOOTER //
// ./src/components/Formsy/RangeInput.js